// Profil métier du tenant courant (business_model) — gating front SANS slug en dur.
// La valeur est persistée dans localStorage par OmniHub au chargement/switch de tenant
// (depuis la réponse /api/platform/user/tenants). "installateur" = pose CEE (OMV, Climat).

export function getBusinessModel() {
  return localStorage.getItem("current_business_model") || "";
}

// 🔴 Les profils métier qui posent du CEE : numéro de devis manuel, moteur
// cumac, secteur via fiche, et surtout la FICHE DOSSIER DÉDIÉE (DossierOmvView).
//
// ⚠️ CASSÉ EN PRODUCTION du 2026-09-06 au 2026-09-08. Ce test valait
// `=== "installateur"`. La consolidation DEC-104/DEC-115 a rectifié
// `omv_france.config.business_model` de « installateur » (valeur erronée) vers
// « omv » — et `/api/platform/user/tenants` sert précisément ce champ dans
// `current_business_model`. Résultat MESURÉ dans les deux bases : la fonction
// rendait FALSE pour OMV, donc `DossierDetail` affichait l'écran GÉNÉRIQUE au
// lieu de la fiche CEE, et `AidesModule` ré-exposait les concepts résidentiels
// (MaPrimeRénov', plafonds de cumul) qu'OMV doit masquer.
//
// 🔑 CE N'ÉTAIT PAS UNE RÈGLE « EN CREUX » — c'est une ÉGALITÉ POSITIVE, et
// c'est pour ça qu'un balayage des seules comparaisons négatives l'a manquée.
// Le défaut n'est pas le SENS du test : c'est de CLOUER une règle à UNE valeur
// d'un vocabulaire qui bouge. Une liste déclarée nomme la famille, et le jour
// où un profil s'ajoute, il s'inscrit ici — visiblement.
export const PROFILS_POSE_CEE = ["installateur", "omv"];

export function isInstallateurProfile() {
  return PROFILS_POSE_CEE.includes(getBusinessModel());
}

// 🔴 LE PARCOURS DE CRÉATION DE DOSSIER — DÉCLARÉ PAR LE SERVEUR, ⛔ JAMAIS DÉDUIT.
//
// ⚠️ TROIS NOTIONS QU'ON CONFONDAIT SUR UNE SEULE LIGNE :
//     `const isOMV = isInstallateurProfile()`
//   · le TENANT ................ QUI c'est               (slug)
//   · le BUSINESS MODEL ........ ce qu'il VEND           (amo, omv, installateur…)
//   · le PROFIL DE CRÉATION .... le PARCOURS qu'il suit  (ci-dessous)
//   Trois noms, trois notions, un seul booléen — et c'est ainsi qu'on a fini
//   par écrire `if (!isOMV) → wizard TEF` : « pas installateur » était devenu
//   « donc AMO ANAH ».
//
// 🔴 CE QUE CETTE FONCTION ⛔ NE FAIT PAS : elle ⛔ ne DÉRIVE RIEN du business
//   model. Deux tenants du même modèle peuvent créer leurs dossiers
//   différemment ; les lier recréerait la déduction qu'on supprime.
//
// 🔑 `null` EST UNE RÉPONSE, ⛔ pas une panne : « ce tenant ⛔ n'a PAS déclaré de
//   parcours ». L'appelant DOIT le dire à l'écran — ⛔ jamais choisir à sa place.
//   ⚠️ `localStorage` ⛔ n'est ICI qu'un CACHE D'AFFICHAGE : l'autorité est
//   `config.dossier_creation_profile`, servi par `/api/platform/user/tenants`.
//   Un cache absent ⇒ on refuse ; ⛔ on ⛔ n'invente PAS un métier.
export function getDossierCreationProfile() {
  const v = localStorage.getItem("current_dossier_creation_profile");
  return v && v.trim() ? v.trim() : null;
}

// 🔴 L'ACTIVITÉ QUE PORTENT LES DOSSIERS DU TENANT — DÉCLARÉE par le serveur.
// ⚠️ ⛔ NE PAS confondre avec `activites_disponibles` de `/api/metier/tenant` :
// celui-là est DÉRIVÉ des modules activés, sur la liste EN DUR ["tef","climat"].
// Un tenant qui n'a NI l'un NI l'autre y reçoit tout à False — et c'est ce qui
// faisait retomber l'écran sur le littéral "tef".
// 🔑 `null` est une RÉPONSE : l'écran le dit, ⛔ il ⛔ ne choisit PAS.
export function getDossierActivite() {
  const v = localStorage.getItem("current_dossier_activite");
  return v && v.trim() ? v.trim() : null;
}

// 🔴 CAPABILITY « MISSIONS AMO » — DÉCLARÉE PAR LE SERVEUR, ⛔ JAMAIS DÉDUITE.
//
// ⚠️ CE QU'ELLE REMPLACE, et pourquoi c'était faux. `CataloguePage` affichait
//   l'onglet « Missions AMO » sur `{!isOmv && …}` — « TOUT LE MONDE SAUF OMV ».
//   Mesuré : `mario_bat` n'est ni TEF ni OMV, il héritait donc d'un concept
//   AMO / MaPrimeAdapt' qui ⛔ ne le concerne PAS, et le voyait à l'écran.
//   🔑 C'est la CINQUIÈME occurrence de la règle EN CREUX : « tout sauf X »
//   change de sens le jour où un X de plus apparaît — et personne ⛔ ne relit
//   la condition ce jour-là.
//
// 🔑 L'AUTORITÉ est celle qu'applique DÉJÀ le backend
//   (`metier_hub/tef/pdf_tenant_config.py`) : les missions AMO n'ont de sens
//   que pour un tenant portant le MODULE AMO. `/api/platform/user/tenants` sert
//   désormais ce fait sous `amo_missions` ; ⛔ l'écran ⛔ ne le devine plus.
//   ⚠️ `localStorage` ⛔ n'est ICI qu'un CACHE D'AFFICHAGE : absent ⇒ on ⛔
//   n'affiche PAS. Refuser par défaut est le seul défaut sûr pour une
//   fonctionnalité d'un AUTRE métier.
export function hasAmoMissions() {
  return localStorage.getItem("current_amo_missions") === "1";
}

// 🔴 CAPACITÉ « PARCOURS AIDES / AMO » — c'est ELLE qui compose la fiche dossier.
// ⚠️ Elle remplace `isTEFRole` (un nom qui MENT : il teste admin/super_admin/
// manager). Un dossier Mario recevait MaPrimeAdapt', Compte ANAH, DAL, Finance
// AMO et Conformité ANAH parce que celui qui le REGARDAIT était administrateur.
// 🔑 Le rôle gouverne les DROITS ; la capacité gouverne la COMPOSITION.
// ⚠️ Absente ⇒ ⛔ AUCUN bloc AMO. L'absence de déclaration ⛔ n'est PAS une
// permission d'hériter de TEF.
export function hasDossierAmo() {
  return localStorage.getItem("current_dossier_amo") === "1";
}

// 🔴 CAPACITÉ « DEVIS DEPUIS CATALOGUE » — DÉCLARÉE par le tenant.
// ⚠️ Remplace `tenants: ["climatpac","omv_france"]` sur l'entrée de menu
// « Devis » — HUITIÈME liste en dur de la semaine. Mario vend ses travaux sur
// devis et ⛔ ne voyait PAS l'entrée ; TEF, lui, a un autre parcours (AMO).
// 🔑 TEF est exclu parce qu'il ⛔ NE DÉCLARE PAS la capacité, ⛔ pas parce qu'on
// l'a nommé. Absente ⇒ ⛔ pas d'entrée : défaut sûr.
export function hasDevisCatalogue() {
  return localStorage.getItem("current_devis_catalogue") === "1";
}

// 🔴 CAPACITÉ « DEVIS AVEC INSTALLATEUR » — DÉCLARÉE (`config.devis_installateur_requis`).
// C'est elle qui donne au wizard devis son étape « Installateur » ; la state machine
// backend l'applique déjà au verrouillage. Absente ⇒ ⛔ pas d'étape : défaut sûr,
// un tenant qui réalise ses propres travaux (Mario) n'a pas d'installateur tiers.
export function hasDevisInstallateurRequis() {
  return localStorage.getItem("current_devis_installateur_requis") === "1";
}

// 🔴 CAPABILITÉ « PENNYLANE » — le tenant a-t-il RÉELLEMENT l'intégration ?
// Source : feature flag tenant `integration.pennylane` (payload
// /platform/user/tenants). ⛔ Aucun contournement super-admin : c'est une
// propriété du TENANT. Absente ⇒ false (INCONNU ≠ ACTIVÉ).
export function hasIntegrationPennylane() {
  return localStorage.getItem("current_integration_pennylane") === "1";
}

// 🔴 CAPABILITÉ « VISITE TERRAIN » — sert à MONTRER L'ENTRÉE vers /mobile/visite.
// ⚠️ Sans elle, l'écran terrain était SERVI mais INATTEIGNABLE depuis l'appli.
// 🔑 Déclarée par la DONNÉE (le tenant a des profils de visite), ⛔ jamais par un
// slug en dur. Absente ⇒ on ⛔ n'affiche PAS : défaut sûr.
// 🔴 L2 (N°876) — le tenant a-t-il ADOPTÉ le modèle Site (un dossier = 1 client
// + 1 site) ? DÉCLARÉ (`tenants.config.dossier_site_requis`) ; absent ⇒ ⛔ rien ne
// change pour ce tenant.
export function hasDossierSite() {
  return localStorage.getItem("current_dossier_site_requis") === "1";
}

// 🔴 CHANTIER — le code du profil de relevé DÉCLARÉ par le tenant
// (`tenants.config.profil_chantier`). Absent ⇒ null ⇒ ⛔ aucun relevé chantier.
// ⛔ Jamais de profil par défaut : un profil deviné serait un métier deviné.
export function profilChantier() {
  try { return localStorage.getItem("current_profil_chantier") || null; } catch { return null; }
}

export function hasVisitesTerrain() {
  return localStorage.getItem("current_visites_terrain") === "1";
}

// Segments commerciaux du tenant courant (liste b2c/b2b), persistés par OmniHub/
// AuthContext depuis /api/platform/user/tenants. Sert de PRESET au défaut de saisie
// type_client ; la primitive is_b2b reste pilotée par le client réel.
export function getSegments() {
  try {
    return JSON.parse(localStorage.getItem("current_segments") || "[]");
  } catch {
    return [];
  }
}

// Régime d'aides du tenant courant (liste : "mpr", "cee", "anah"), persisté par
// OmniHub depuis /api/platform/user/tenants → config.regime_aides. Source du gating
// MPR par RÉGIME (jamais par slug). Défaut sûr = [] si absent/illisible.
export function getRegimeAides() {
  try {
    return JSON.parse(localStorage.getItem("current_regime_aides") || "[]");
  } catch {
    return [];
  }
}

// Défaut type_client dérivé des segments du tenant : un tenant PUREMENT b2b
// (ex OMV) pré-sélectionne "professionnel" ; sinon (b2c, mixte, ou inconnu) on
// garde le défaut sûr "particulier". Pur / testable.
export function defaultClientTypeForSegments(segments) {
  const s = Array.isArray(segments) ? segments : [];
  if (s.length === 1 && s[0] === "b2b") return "professionnel";
  return "particulier";
}

export function defaultClientType() {
  return defaultClientTypeForSegments(getSegments());
}
